module.exports = ".row:nth-child(odd){\r\n    background-color: #dee2e6;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/correspondence-tracking/ct-form/ct-form.component.css
// module id = ./src/app/correspondence-tracking/ct-form/ct-form.component.css
// module chunks = main